import { getData } from "../api/api";

export type BusinessErrorEvent = {
  id: string;
  occurredAt: string;
  businessErrorCode: string;
  errorCategory: string;
  message: string;
  httpStatus: number;
  username?: string;
  tenantId?: string;
  requestPath?: string;
  requestMethod?: string;
};

type PagedBusinessErrorResponse = {
  content?: BusinessErrorEvent[];
  page?: {
    size?: number;
    totalElements?: number;
    totalPages?: number;
    number?: number;
  };
};

export const businessErrorService = {
  list: async (from?: string, to?: string): Promise<PagedBusinessErrorResponse> => {
    const params = new URLSearchParams();
    if (from) params.append("from", from);
    if (to) params.append("to", to);

    const query = params.toString();
    const endpoint = query ? `/admin/business-errors?${query}` : "/admin/business-errors";
    return getData(endpoint);
  },
};

